import script from "./user-select.vue?vue&type=script&setup=true&lang=js"
export * from "./user-select.vue?vue&type=script&setup=true&lang=js"

import "./user-select.vue?vue&type=style&index=0&id=b934ee24&lang=scss&scoped=true"
import "./user-select.vue?vue&type=style&index=1&id=b934ee24&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b934ee24"]])

export default __exports__